import { render, staticRenderFns } from "./SideBarHeader.vue?vue&type=template&id=16abad51&scoped=true&"
import script from "./SideBarHeader.vue?vue&type=script&lang=js&"
export * from "./SideBarHeader.vue?vue&type=script&lang=js&"
import style0 from "./SideBarHeader.vue?vue&type=style&index=0&id=16abad51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16abad51",
  null
  
)

export default component.exports